import { type FC, type ReactNode } from 'react';
import {
  type BaseProps,
  type ComponentSize,
} from 'src/modules/shared/types/component.type';

interface PanelHeaderProps extends BaseProps {
  children: ReactNode;
  actions?: ReactNode;
  border?: boolean;
  fixed?: boolean;
  size?: ComponentSize;
  containerClassName?: string;
  childrenClassName?: string;
  actionsClassName?: string;
  collapsible?: boolean;
  scrollable?: boolean;
}

export const PanelHeader: FC<PanelHeaderProps> = ({
  children,
  actions,
  border = true,
  fixed = false,
  size = 'md',
  className = '',
  containerClassName = '',
  childrenClassName = '',
  actionsClassName = '',
  collapsible = true,
  scrollable = false,
}) => {
  const hasExplicitHorizontalPadding =
    /\bpx-\S+/.test(className) ||
    /\bpl-\S+/.test(className) ||
    /\bpr-\S+/.test(className);
  const heightClasses: Record<ComponentSize, string> = {
    '2xs': 'h-12',
    xs: 'h-14',
    sm: 'h-16',
    md: 'h-20',
    lg: 'h-20',
  };

  return (
    <div
      className={`
        flex items-center justify-between
        ${border ? 'border-b border-gray-200' : ''}
        ${fixed ? heightClasses[size] : ''}
        ${scrollable ? 'overflow-x-auto overflow-y-hidden' : ''}
        ${className}
      `}
    >
      <div
        className={`
          flex justify-between w-full ${hasExplicitHorizontalPadding ? '' : 'px-4'} gap-2
          ${scrollable ? 'min-w-max flex-nowrap items-center' : collapsible ? 'flex-row flex-wrap items-start gap-y-3 sm:items-center' : 'flex-row items-center'}
          ${fixed ? 'h-full min-h-0' : ''}
          ${containerClassName}
        `}
      >
        <div
          className={`
            flex flex-row ${collapsible && !scrollable ? '' : 'flex-1'}
            ${fixed ? 'min-h-0' : ''}
            ${childrenClassName}
          `}
        >
          {children}
        </div>

        {actions && (
          <div
            className={`flex items-center gap-2 flex-shrink-0 ${actionsClassName}`}
          >
            {actions}
          </div>
        )}
      </div>
    </div>
  );
};
